import type { AnalyticsObject, AnalyticsProperties } from '../types'
export class Navigation implements AnalyticsObject {
  name: string
  properties: NavigationProperties
  constructor(properties: NavigationProperties) {
    this.name = `Navigation`
    this.properties = properties
  }
}
export interface NavigationProperties extends AnalyticsProperties {
  navigationMenuLabel?: string | null
  navigationItemTargetUrl?: string | null
  navigationItemType?: string | null
  navigationItemLocation?: 'header' | 'footer' | null
}
